import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveGame, selectOpponent, selectPlayer } from '../ActiveGame/selectors';
import { selectCardsById } from '../Cards/selectors';
import { PlainButton } from '../Controls';
import { revealedLines } from './revealedLines';
import { Notice } from './styled';

/**
 * The hands a Trainer showed to both players (Lass), until dismissed. Tagged with the game version they were shown
 * in, like the coin flips.
 */
const RevealedHands = () => {
  const revealed = useSelector(selectActiveGame).get('revealed');
  const cardsById = useSelector(selectCardsById);
  const player = useSelector(selectPlayer);
  const opponent = useSelector(selectOpponent);
  const [dismissedVersion, setDismissedVersion] = useState(null);

  if (!revealed || revealed.get('version') === dismissedVersion) {
    return null;
  }

  const cardName = (id) => cardsById.getIn([id, 'name'], 'a card');
  const lines = revealedLines(
    revealed.toJS(),
    cardName,
    player.getIn(['user', 'id']),
    opponent ? opponent.getIn(['user', 'name'], 'Your opponent') : 'Your opponent',
  );

  return (
    <Notice role="status" aria-label="Hands shown">
      <ul>
        {lines.map(line => <li key={line}>{line}</li>)}
      </ul>
      <PlainButton onClick={() => setDismissedVersion(revealed.get('version'))}>OK</PlainButton>
    </Notice>
  );
};

export default RevealedHands;
